import type { Options } from "highcharts";

import { colorsPalettes, rgba } from "@similarweb/styles";

import { percentageSignOnlyFilter } from "app/filters/ngFilters";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import noLegendConfig from "pro-features/components/Chart/src/configs/legend/noLegendConfig";
import { i18nFilter } from "app/filters/i18nFilter";

const formatPercentage = (value: number): string => {
    return percentageSignOnlyFilter()(value, 0);
};
const i18n = i18nFilter();

export const getMarketDistributionBarChartConfig = ({ type }): Options => {
    const marketDistributionChartOptions: Options = {
        chart: {
            type: "column",
            animation: false,
            borderColor: colorsPalettes.carbon[0],
            height: 200,
            margin: [18, 0, 45, 60],
            style: {
                fontFamily: "Arial",
                fontSize: "11px",
            },
        },
        plotOptions: {
            series: {
                states: {
                    hover: {
                        enabled: false,
                    },
                },
            },
            column: {
                groupPadding: 0.45,
                grouping: true,
                maxPointWidth: 35,
                minPointLength: 3,
                pointPadding: 0.1,
                pointWidth: 80,
                dataLabels: {
                    enabled: false,
                },
            },
        },
        tooltip: {
            borderRadius: 3,
            backgroundColor: colorsPalettes.carbon[0],
            borderWidth: 0,
            style: {
                color: colorsPalettes.carbon[500],
                fontWeight: "400",
                fontSize: "12px",
                fontFamily: "Roboto",
                border: "none",
                boxShadow: `(0px 18px 34px ${rgba(colorsPalettes.carbon[500], 0.12)}`,
            },
            formatter() {
                return i18n("market.analysis.industry.overview.market.distribution.bar.chart.tooltip", {
                    percentage: formatPercentage(this.y),
                    xAxisValue: this.category,
                });
            },
        },
        yAxis: {
            max: 100,
            min: 0,
            tickInterval: 25,
            gridLineWidth: 1,
            showFirstLabel: true,
            showLastLabel: true,
            reversed: false,
            gridZIndex: 2,
            reversedStacks: true,
            title: {
                text: i18n("market.analysis.industry.overview.market.distribution.y.axis.title"),
                rotation: 270,
                margin: 10,
                style: {
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    color: colorsPalettes.carbon[250],
                },
            },
            labels: {
                format: "{value}%",
                x: -5,
                style: {
                    fontSize: "11px",
                    fontFamily: "Roboto",
                    color: colorsPalettes.carbon[400],
                },
            },
        },
        xAxis: {
            gridLineWidth: 0,
            gridLineDashStyle: "Dash",
            tickLength: 5,
            categories: ["1%", "1%-5%", "5%-10%", "10%-50%", "50%-100%"],
            title: {
                text: i18n("market.analysis.industry.overview.market.distribution.x.axis.title"),
                style: {
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    color: colorsPalettes.carbon[250],
                },
                margin: 10,
            },
            labels: {
                y: 18,
                style: {
                    textTransform: "capitalize",
                    fontSize: "11px",
                    color: colorsPalettes.carbon[400],
                    fontFamily: "Roboto",
                },
            },
        },
    };

    return combineConfigs({ type }, [noLegendConfig, marketDistributionChartOptions]);
};
